export default __webpack_public_path__ + "static/media/3.89c93376.webp";